// Blog page entry point

import { initSwiperBlogWithResize } from './swiper-blog.js';

// ─── Swipers ──────────────────────────────────────────────────────────────────

initSwiperBlogWithResize();
